/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown>, bpm: NonNullable<unknown> }} Ui_Laps_Row_Range_RecoveryInputs */

const en_ui_laps_row_range_recovery = /** @type {(inputs: Ui_Laps_Row_Range_RecoveryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.range} · recovery ${i?.bpm} bpm`)
};

const de_ui_laps_row_range_recovery = /** @type {(inputs: Ui_Laps_Row_Range_RecoveryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.range} · Erholung ${i?.bpm} bpm`)
};

/**
* | output |
* | --- |
* | "{range} · recovery {bpm} bpm" |
*
* @param {Ui_Laps_Row_Range_RecoveryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_row_range_recovery = /** @type {((inputs: Ui_Laps_Row_Range_RecoveryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Row_Range_RecoveryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_row_range_recovery(inputs)
	return de_ui_laps_row_range_recovery(inputs)
});